import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';

import { flatRoutingConfiguration } from '@app/core/helper/flat-routing-configuration';
import { ChannelListControllerWithContext } from '@app/feature/channel/channel-list/channel-list.controller';
import { ChargePointDetailsPage } from '@app/feature/charge-point/charge-point-details/charge-point-details.controller';
import { ChargePointListControllerWithContext } from '@app/feature/charge-point/charge-point-list/charge-point-list.controller';
import { CustomerDetailsPage } from '@app/feature/customer/customer-details/customer-details.controller';
import { CustomerListControllerWithContext } from '@app/feature/customer/customer-list/customer-list.controller';
import { DashboardView } from '@app/feature/dashboard/dashboard.view';
import { EmspBoChargingSessionDetailsPage } from '@app/feature/emsp-bo-charging-session/emsp-bo-charging-session-details/emsp-bo-charging-session-details.controller';
import { EmspBoChargingSessionListControllerWithContext } from '@app/feature/emsp-bo-charging-session/emsp-bo-charging-session-list/emsp-bo-charging-session-list.controller';
import { EmspBoEmspUserDetailsPage } from '@app/feature/emsp-bo-emsp-user/emsp-bo-emsp-user-details/emsp-bo-emsp-user-details.controller';
import { EmspBoEmspUserListControllerWithContext } from '@app/feature/emsp-bo-emsp-user/emsp-bo-emsp-user-list/emsp-bo-emsp-user-list.controller';
import { EmspBoInvoiceDetailsPage } from '@app/feature/emsp-bo-invoice/emsp-bo-invoice-details/emsp-bo-invoice-details.controller';
import { EmspBoInvoiceListControllerWithContext } from '@app/feature/emsp-bo-invoice/emsp-bo-invoice-list/emsp-bo-invoice-list.controller';
import { EmspBoLocationDetailsPage } from '@app/feature/emsp-bo-location/emsp-bo-location-details/emsp-bo-location-details.controller';
import { EmspBoRfidBadgeOrderDetailsPage } from '@app/feature/emsp-bo-rfid-badge-order/emsp-bo-rfid-badge-order-details/emsp-bo-rfid-badge-order-details.controller';
import { EmspBoRfidBadgeOrderListControllerWithContext } from '@app/feature/emsp-bo-rfid-badge-order/emsp-bo-rfid-badge-order-list/emsp-bo-rfid-badge-order-list.controller';
import { EmspBoTariffDetailsPage } from '@app/feature/emsp-bo-tariff/emsp-bo-tariff-details/emsp-bo-tariff-details.controller';
import { EmspBoTariffListControllerWithContext } from '@app/feature/emsp-bo-tariff/emsp-bo-tariff-list/emsp-bo-tariff-list.controller';
import { InvoiceDetailsPage } from '@app/feature/invoice/invoice-details/invoice-details.controller';
import { InvoiceListControllerWithContext } from '@app/feature/invoice/invoice-list/invoice-list.controller';
import { LocationDetailsPage } from '@app/feature/location/location-details/location-details.controller';
import { LocationListControllerWithContext } from '@app/feature/location/location-list/location-list.controller';
import { MustResetPasswordController } from '@app/feature/must-reset-password/must-reset-password.controller';
import { NetworkDetailsPage } from '@app/feature/network/network-details/network-details.controller';
import { NetworkListControllerWithContext } from '@app/feature/network/network-list/network-list.controller';
import { ProfileController } from '@app/feature/profile/profile.controller';
import { RoleDetailsPage } from '@app/feature/role/role-details/role-details.controller';
import { RoleListControllerWithContext } from '@app/feature/role/role-list/role-list.controller';
import { StatisticsController } from '@app/feature/statistics/statistics.controller';
import { TariffDetailsPage } from '@app/feature/tariff/tariff-details/tariff-details.controller';
import { TariffListControllerWithContext } from '@app/feature/tariff/tariff-list/tariff-list.controller';
import { TicketDetailsPage } from '@app/feature/ticket/ticket-details/ticket-details.controller';
import { TicketController } from '@app/feature/ticket/ticket.controller';
import { TokenDetailsPage } from '@app/feature/token/token-details/token-details.controller';
import { TokenListControllerWithContext } from '@app/feature/token/token-list/token-list.controller';
import { TransactionDetailsPage } from '@app/feature/transaction/transaction-details/transaction-details.controller';
import { TransactionListControllerWithContext } from '@app/feature/transaction/transaction-list/transaction-list.controller';
import { UserDetailsPage } from '@app/feature/user/user-details/user-details.controller';
import { UserListControllerWithContext } from '@app/feature/user/user-list/user-list.controller';

import { APP_PATH } from 'src/config/app-paths';
import {
  GroupEnum,
  RoutingConfigurationModel,
} from 'src/core/model/routing-configuration.model';
import { SettingsController } from 'src/feature/settings/settings.controller';

import { EmspBoEmspLocationListControllerWithContext } from '../feature/emsp-bo-location/emsp-bo-location-list/emsp-bo-location-list.controller';

export const RoutingConfiguration: RoutingConfigurationModel[] = [
  {
    labelKey: '$.profile.title',
    controller: ProfileController,
    route: APP_PATH.PROFILE,
    showInMenu: false,
    icon: 'user-01',
  },
  {
    labelKey: '$.settings.title',
    route: APP_PATH.SETTINGS,
    controller: SettingsController,
    showInMenu: false,
    icon: 'settings-01',
  },
  // GroupEnum.DASHBOARD
  {
    labelKey: '$.dashboard.title',
    controller: DashboardView,
    route: APP_PATH.DASHBOARD,
    showInMenu: true,
    group: GroupEnum.DASHBOARD,
    icon: 'grid-01',
  },
  {
    labelKey: '$.statistics.title',
    controller: StatisticsController,
    route: APP_PATH.STATISTICS,
    showInMenu: true,
    group: GroupEnum.DASHBOARD,
    icon: 'line-chart-up-01',
  },
  {
    labelKey: '$.invoice-list.title',
    controller: InvoiceListControllerWithContext,
    route: APP_PATH.INVOICE.LIST,
    showInMenu: true,
    group: GroupEnum.DASHBOARD,
    icon: 'file-05',
    permission: {
      action: ActionsByResource.INVOICES.READ,
      resourceName: Resource.INVOICES,
    },
  },
  {
    labelKey: '$.invoice-details.title',
    controller: InvoiceDetailsPage,
    route: APP_PATH.INVOICE.DETAILS,
    showInMenu: false,
    icon: 'file-05',
    parentRoute: APP_PATH.INVOICE.LIST,
    permission: {
      action: ActionsByResource.INVOICES.READ,
      resourceName: Resource.INVOICES,
    },
  },
  // GroupEnum.CUSTOMERS
  {
    labelKey: '$.customer-list.title',
    controller: CustomerListControllerWithContext,
    route: APP_PATH.CUSTOMER.LIST,
    showInMenu: true,
    group: GroupEnum.CUSTOMERS,
    icon: 'dataflow-04',
    permission: {
      action: ActionsByResource.CUSTOMERS.READ,
      resourceName: Resource.CUSTOMERS,
    },
  },
  {
    labelKey: '$.customer-details.title',
    controller: CustomerDetailsPage,
    route: APP_PATH.CUSTOMER.DETAILS,
    showInMenu: false,
    icon: 'dataflow-04',
    parentRoute: APP_PATH.CUSTOMER.LIST,
    permission: {
      action: ActionsByResource.CUSTOMERS.READ,
      resourceName: Resource.CUSTOMERS,
    },
  },
  {
    labelKey: '$.user-list.title',
    route: APP_PATH.USER.LIST,
    controller: UserListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CUSTOMERS,
    icon: 'users-01',
    permission: {
      action: ActionsByResource.USERS.READ,
      resourceName: Resource.USERS,
    },
  },
  {
    labelKey: '$.user-details.title',
    route: APP_PATH.USER.DETAILS,
    controller: UserDetailsPage,
    showInMenu: false,
    icon: 'users-01',
    parentRoute: APP_PATH.USER.LIST,
    permission: {
      action: ActionsByResource.USERS.READ,
      resourceName: Resource.USERS,
    },
  },
  {
    labelKey: '$.role-list.title',
    route: APP_PATH.ROLE.LIST,
    controller: RoleListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CUSTOMERS,
    icon: 'settings-04',
    permission: {
      action: ActionsByResource.ROLES.READ,
      resourceName: Resource.ROLES,
    },
  },
  {
    labelKey: '$.role-details.title',
    route: APP_PATH.ROLE.DETAILS,
    controller: RoleDetailsPage,
    showInMenu: false,
    icon: 'settings-04',
    parentRoute: APP_PATH.ROLE.LIST,
    permission: {
      action: ActionsByResource.ROLES.READ,
      resourceName: Resource.ROLES,
    },
  },
  // GroupEnum.CHARGE_POINTS
  {
    labelKey: '$.network-list.title',
    route: APP_PATH.NETWORK.LIST,
    controller: NetworkListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'server-06',
    permission: {
      action: ActionsByResource.NETWORKS.READ,
      resourceName: Resource.NETWORKS,
    },
  },
  {
    labelKey: '$.network-details.title',
    route: APP_PATH.NETWORK.DETAILS,
    controller: NetworkDetailsPage,
    showInMenu: false,
    icon: 'server-06',
    parentRoute: APP_PATH.NETWORK.DETAILS,
    permission: {
      action: ActionsByResource.NETWORKS.READ,
      resourceName: Resource.NETWORKS,
    },
  },
  {
    labelKey: '$.location-list.title',
    route: APP_PATH.LOCATION.LIST,
    controller: LocationListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'location',
    permission: {
      action: ActionsByResource.LOCATIONS.READ,
      resourceName: Resource.LOCATIONS,
    },
  },
  {
    labelKey: '$.location-details.title',
    route: APP_PATH.LOCATION.DETAILS,
    controller: LocationDetailsPage,
    showInMenu: false,
    icon: 'location',
    parentRoute: APP_PATH.LOCATION.LIST,
    permission: {
      action: ActionsByResource.LOCATIONS.READ,
      resourceName: Resource.LOCATIONS,
    },
  },
  {
    labelKey: '$.charge-point-list.title',
    route: APP_PATH.CHARGE_POINT.LIST,
    controller: ChargePointListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'electric-terminal-3',
  },
  {
    labelKey: '$.channel-list.title',
    route: APP_PATH.CHANNEL.LIST,
    controller: ChannelListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'electric-terminal',
  },
  {
    labelKey: '$.charge-point-details.title',
    route: APP_PATH.CHARGE_POINT.DETAILS,
    controller: ChargePointDetailsPage,
    showInMenu: false,
    icon: 'electric-terminal-3',
    parentRoute: APP_PATH.CHARGE_POINT.LIST,
  },
  {
    labelKey: '$.transaction-list.title',
    route: APP_PATH.TRANSACTION.LIST,
    controller: TransactionListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'electric-car-2',
    permission: {
      action: ActionsByResource.TRANSACTIONS.READ,
      resourceName: Resource.TRANSACTIONS,
    },
  },
  {
    labelKey: '$.transaction-details.title',
    route: APP_PATH.TRANSACTION.DETAILS,
    controller: TransactionDetailsPage,
    showInMenu: false,
    icon: 'electric-car-2',
    parentRoute: APP_PATH.TRANSACTION.LIST,
    permission: {
      action: ActionsByResource.TRANSACTIONS.READ,
      resourceName: Resource.TRANSACTIONS,
    },
  },
  {
    labelKey: '$.tariff-list.title',
    route: APP_PATH.TARIFF.LIST,
    controller: TariffListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.CHARGE_POINTS,
    icon: 'currency-euro-circle',
    permission: {
      action: ActionsByResource.TARIFFS.READ,
      resourceName: Resource.TARIFFS,
    },
  },
  {
    labelKey: '$.tariff-details.title',
    route: APP_PATH.TARIFF.DETAILS,
    controller: TariffDetailsPage,
    showInMenu: false,
    icon: 'currency-euro-circle',
    parentRoute: APP_PATH.TARIFF.LIST,
    permission: {
      action: ActionsByResource.TARIFFS.READ,
      resourceName: Resource.TARIFFS,
    },
  },
  {
    labelKey: '$.token-list.title',
    route: APP_PATH.TOKEN.LIST,
    controller: TokenListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.USERS_VE,
    icon: 'credit-card-01',
    permission: {
      action: ActionsByResource.TOKENS.READ,
      resourceName: Resource.TOKENS,
    },
  },
  {
    labelKey: '$.token-details.title',
    route: APP_PATH.TOKEN.DETAILS,
    controller: TokenDetailsPage,
    showInMenu: false,
    group: GroupEnum.USERS_VE,
    icon: 'credit-card-01',
    parentRoute: APP_PATH.TOKEN.LIST,
    permission: {
      action: ActionsByResource.TOKENS.READ,
      resourceName: Resource.TOKENS,
    },
  },
  {
    labelKey: '$.emsp-bo-rfid-badge-order-list.title',
    route: APP_PATH.EMSP_BO_RFID_BADGE_ORDER.LIST,
    controller: EmspBoRfidBadgeOrderListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'credit-card-refresh',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_RFID_BADGE_ORDER,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-rfid-badge-order-details.title',
    route: APP_PATH.EMSP_BO_RFID_BADGE_ORDER.DETAILS,
    controller: EmspBoRfidBadgeOrderDetailsPage,
    showInMenu: false,
    group: GroupEnum.EMSP,
    icon: 'credit-card-refresh',
    parentRoute: APP_PATH.EMSP_BO_RFID_BADGE_ORDER.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_RFID_BADGE_ORDER,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-tariff-list.title',
    route: APP_PATH.EMSP_BO_TARIFF.LIST,
    controller: EmspBoTariffListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'currency-euro-circle',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_TARIFF,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-tariff-details.title',
    route: APP_PATH.EMSP_BO_TARIFF.DETAILS,
    controller: EmspBoTariffDetailsPage,
    showInMenu: false,
    group: GroupEnum.EMSP,
    icon: 'currency-euro-circle',
    parentRoute: APP_PATH.EMSP_BO_TARIFF.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_TARIFF,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-emsp-user-list.title',
    route: APP_PATH.EMSP_BO_EMSP_USER.LIST,
    controller: EmspBoEmspUserListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'users-01',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_EMSP_USER,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-emsp-user-details.title',
    route: APP_PATH.EMSP_BO_EMSP_USER.DETAILS,
    controller: EmspBoEmspUserDetailsPage,
    showInMenu: false,
    icon: 'user-01',
    parentRoute: APP_PATH.EMSP_BO_EMSP_USER.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_EMSP_USER,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-charging-session-list.title',
    route: APP_PATH.EMSP_BO_CHARGING_SESSION.LIST,
    controller: EmspBoChargingSessionListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'electric-car-2',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_SESSION,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-charging-session-details.title',
    route: APP_PATH.EMSP_BO_CHARGING_SESSION.DETAILS,
    controller: EmspBoChargingSessionDetailsPage,
    showInMenu: false,
    group: GroupEnum.EMSP,
    icon: 'electric-car-2',
    parentRoute: APP_PATH.EMSP_BO_CHARGING_SESSION.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_SESSION,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-invoice-list.title',
    route: APP_PATH.EMSP_BO_INVOICE.LIST,
    controller: EmspBoInvoiceListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'file-05',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_INVOICE,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-invoice-details.title',
    route: APP_PATH.EMSP_BO_INVOICE.DETAILS,
    controller: EmspBoInvoiceDetailsPage,
    showInMenu: false,
    icon: 'file-05',
    parentRoute: APP_PATH.EMSP_BO_INVOICE.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_INVOICE,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-location-list.title',
    route: APP_PATH.EMSP_BO_EMSP_LOCATION.LIST,
    controller: EmspBoEmspLocationListControllerWithContext,
    showInMenu: true,
    group: GroupEnum.EMSP,
    icon: 'location',
    permission: {
      action: ActionsByResource.EMSP_BO.READ_LOCATION,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.emsp-bo-location-details.title',
    route: APP_PATH.EMSP_BO_EMSP_LOCATION.DETAILS,
    controller: EmspBoLocationDetailsPage,
    showInMenu: false,
    group: GroupEnum.EMSP,
    icon: 'location',
    parentRoute: APP_PATH.EMSP_BO_EMSP_LOCATION.LIST,
    permission: {
      action: ActionsByResource.EMSP_BO.READ_LOCATION,
      resourceName: Resource.EMSP_BO,
    },
  },
  {
    labelKey: '$.ticket-list.title',
    route: APP_PATH.TICKET.LIST,
    controller: TicketController,
    showInMenu: true,
    group: GroupEnum.SUPPORT,
    icon: 'clipboard',
    permission: {
      action: ActionsByResource.TICKETS.READ,
      resourceName: Resource.TICKETS,
    },
  },
  {
    labelKey: '$.ticket-details.title',
    route: APP_PATH.TICKET.DETAILS,
    controller: TicketDetailsPage,
    showInMenu: false,
    group: GroupEnum.SUPPORT,
    icon: 'clipboard',
    parentRoute: APP_PATH.TICKET.LIST,
    permission: {
      action: ActionsByResource.TICKETS.READ,
      resourceName: Resource.TICKETS,
    },
  },
  {
    labelKey: '$.must-reset-password.title',
    route: APP_PATH.MUST_RESET_PASSWORD,
    controller: MustResetPasswordController,
    icon: 'shield-01',
  },
];

export const FlatRoutingConfiguration =
  flatRoutingConfiguration(RoutingConfiguration);
